import moment from "moment";
import React, { Component } from "react";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { Redirect } from "react-router-dom";
import Comm from "../comm/comm";
import Context from "../context/context";
import Translation from "../translation/translation";

export default class Payments extends Component {
    constructor(props) {
        super(props);
        if (!Comm.ValidSession()) return;

        this.state = {};

        this.CanSave = this.CanSave.bind(this);
        this.Save = this.Save.bind(this);
        this.ShowOK = this.ShowOK.bind(this);
        this.ShowError = this.ShowError.bind(this);
    }

    componentDidMount() {
        var sid = Context.GetContext().Sid;
        var ibans = Comm.CallServerFunction("invoices/accounts", {
            session: sid,
            visible_only: true,
        }).accounts;
        this.setState({ ibans: ibans });
    }

    CanSave() {
        var can =
            this.state.toInvoice &&
            this.state.toInvoice.length > 0 &&
            parseFloat(this.state.sum) > 0 &&
            this.state.date &&
            this.state.iban;
        if (can)
            return (
                <button className="btn btn-primary" onClick={this.Save}>
                    {Translation.Trans("save")}
                </button>
            );
        else return null;
    }

    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return <Redirect to="/login" push></Redirect>;
        }

        if (Context.RenderNotOK(this.props.history)) return null;

        var self = this;

        return (
            <div className="panel panel-default">
                <div className="panel-heading">{Translation.Trans("payments")}</div>
                <div className="panel-body">
                    <div className="row">
                        <div className="col-md-3">
                            <label className="control-label">{Translation.Trans("toinvoice")}</label>
                            <input
                                type="text"
                                className="form-control"
                                value={this.state.toInvoice || ""}
                                onChange={(e) => self.setState({ toInvoice: e.target.value })}
                            ></input>
                        </div>
                        <div className="col-md-3">
                            <label className="control-label">{Translation.Trans("sum")}</label>
                            <input
                                type="text"
                                className="form-control"
                                value={this.state.sum || ""}
                                onChange={(e) => self.setState({ sum: e.target.value })}
                            ></input>
                        </div>
                        <div className="col-md-3">
                            <label className="control-label">{Translation.Trans("date")}</label>
                            <Datetime
                                inputProps={{
                                    placeholder: "N/A",
                                    readOnly: "true",
                                    className: "form-control pointhand",
                                }}
                                dateFormat="DD.MM.YYYY"
                                timeFormat=""
                                onChange={(e) => self.setState({ date: e })}
                                value={this.state.date || ""}
                                closeOnSelect={true}
                            ></Datetime>
                        </div>
                        <div className="col-md-3">
                            <label className="control-label">{Translation.Trans("iban")}</label>
                            <select
                                className="form-control"
                                value={this.state.iban || ""}
                                onChange={(e) => self.setState({ iban: e.target.value })}
                            >
                                <option></option>
                                {(self.state.ibans || []).map((x) => (
                                    <option value={x.iban}>{x.iban}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">{self.CanSave()}</div>
                        <div className="col-md-3">
                            {self.state.ok ? (
                                <span style={{ fontWeight: "bold", color: "#00ff00" }}>
                                    {Translation.Trans("successfulsave")}
                                </span>
                            ) : null}
                            {self.state.error ? (
                                <span style={{ fontWeight: "bold", color: "#ff0000" }}>
                                    {Translation.Trans("error") + ": " + self.state.error}
                                </span>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    ShowOK() {
        var self = this;
        this.setState({ ok: true, error: null, toInvoice: null, sum: null, date: null, iban: null }, () =>
            window.setTimeout(() => self.setState({ ok: false }), 5000)
        );
    }
    ShowError(error) {
        //var self = this;
        this.setState({ ok: false, error: error });
    }

    Save() {
        var data = {};
        var sid = Context.GetContext().Sid;
        data.session = sid;
        data.to_invoice = this.state.toInvoice;
        data.sum = this.state.sum;
        data.dt = moment(this.state.date).format("YYYYMMDD");
        data.iban = this.state.iban;

        Comm.SavePayment(data, this.ShowOK, this.ShowError);
    }
}



// WEBPACK FOOTER //
// ./src/pages/payments.js